<template>
  <div
    class="navbar-item has-dropdown navbar-item-profile"
    :class="{ 'is-active': active }"
    @click="active = !active"
  >
    <a class="navbar-link"
      >{{ email }}<i class="material-icons">&#xE5C5;</i>
      <vue-gravatar :email="email" :size="40" default-img="mm" />
    </a>
    <div class="navbar-dropdown is-boxed is-center">
      <router-link
        v-if="userType === 'journeys'"
        :to="{
          name: 'audience-user',
          params: { appId: appId, userId: userId },
        }"
        class="navbar-item"
        active-class="is-active"
        >{{ $t('navbar.dropdown.my_profile') }}</router-link
      >
      <router-link
        to="/settings"
        class="navbar-item"
        active-class="is-active"
        >{{ $t('settings.title') }}</router-link
      >
      <a class="navbar-item navbar-item-logout" @click="logout()">{{
        $t('navbar.dropdown.logout_link')
      }}</a>
    </div>
  </div>
</template>

<script>
import Auth from 'services/Auth';
import VueGravatar from 'vue-gravatar';
import Dropdown from 'views/mixins/dropdown';
import { mapState } from 'vuex';

export default {
  extends: Dropdown,

  components: {
    VueGravatar,
  },

  computed: {
    ...mapState('account', ['userId', 'appId', 'userType']),
    email() {
      const email = this.$store.state.account.email || '';
      return email.split('@')[0];
    },
  },

  methods: {
    logout() {
      Auth.logout();
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar-item-profile {
  .navbar-link {
    i {
      margin-right: 0.5rem;
    }

    img {
      border-radius: 50%;
    }
  }
}

.navbar-link,
.tag {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.25rem;
}
</style>
